/*
 * Filename: config-tab-header.component.tsx
 * Description: Component for config tab header.
 */


import React from 'react';
import { CQAppConstant } from '../../app-constants';

export const ConfigHeaderTabs = (props: { isLayoutApplicable: boolean, componentTabState: boolean,templateName: string, togglecomponentTabState: () => void }) => {
    return (
        <ul className="slds-tabs_default__nav sdls-grid" role="tablist">
            <li onClick={() => { props.togglecomponentTabState(); }}
                className={`slds-tabs_default__item slds-col slds-text-align_center ${props.componentTabState ? 'slds-is-active' : ''}`}
                title="Item One" role="presentation">
                <div className="slds-tabs_default__link"
                    role="tab" tabIndex={0} aria-selected={props.componentTabState} aria-controls="tab-default-1" id="tab-default-1__item">
                    {CQAppConstant.TEMPLATE_CONFIG_TABS.COMPONENT_CONFIG_TAB}</div>
            </li>
            {(props.isLayoutApplicable || props.templateName===CQAppConstant.CQNBA) &&
                <li
                    onClick={() => { props.togglecomponentTabState(); }}
                    className={`slds-tabs_default__item slds-col slds-text-align_center ${!props.componentTabState ? 'slds-is-active' : ''}`}
                    title="Item Two" role="presentation">
                    <div className="slds-tabs_default__link"
                        role="tab" tabIndex={-1} aria-selected={!props.componentTabState} aria-controls="tab-default-2" id="tab-default-2__item">
                        {CQAppConstant.TEMPLATE_CONFIG_TABS.LAYOUT_CONFIG_TAB}
                    </div>
                </li>
            }
        </ul>
    );
};

